import React, { Component } from 'react';
import Switch from "react-switch";

class BecaPreg extends Component {
    state = {
        chk: false
    }

    componentWillReceiveProps = (props) => {
        let control = false
        if (props.select === props.datos.id) control = true
        this.setState ({ chk: control })
    }

    cambiaSwitch = () => {
        this.setState({
            chk: !this.state.chk
        }, () => {
            (this.state.chk === false) ? this.props.funcion("") : this.props.funcion(this.props.datos.id)
        })
    }

    render() {
        const { datos } = this.props;
        let { chk } = this.state;

        const styles = {
            padding: 5, fontSize: 12
        }

        return (
            <tr>
                <td style={styles} width="70px" align="center">{datos.id}</td>
                <td style={styles}>{datos.nombre}</td>
                <td style={styles} width="80px" align="center"><Switch height={12} width={24} onChange={this.cambiaSwitch} checked={chk} /></td>
            </tr>
        );
    }
}
 
export default BecaPreg;


// WEBPACK FOOTER //
// ./src/views/EstSolicitudes/BecaPreg.jsx